import { ErrorBase } from '@/errors/ErrorBase';

export class CloudIdEmptyError extends ErrorBase {
    static get defaultMessage(): string {
        return 'クラウドIDが未入力です。';
    }

    static get errorName(): string {
        return 'CloudIdEmptyError';
    }
}
